import { Icon } from "@screencloud/screencloud-ui-components";
import { memo } from "react";
import { appInstanceIconUrl } from "src/helpers/appHelper";
import { AppPickerItem } from "src/components/QuickPostPicker/styles";
import { AvailableAppInstanceFragment } from "src/types.g";
import { MediaTitle } from "src/components/MediaTitle";

interface QuickPostInstanceItemProps {
  app: AvailableAppInstanceFragment;
  selected: boolean;
  onToggleSelection: (app: AvailableAppInstanceFragment) => void;
  onClickTag: (tag: string) => void;
}

const ThumbnailPreview = memo<{ iconUrl: string; name: string }>(
  ({ iconUrl, name }) => (
    <div className="thumbnail-preview">
      <div className="thumbnail">
        <div className="wrapper">
          <img src={iconUrl} alt={name} />
        </div>
      </div>
    </div>
  ),
);

const QuickPostInstanceItem = memo<QuickPostInstanceItemProps>(
  ({ app, selected, onToggleSelection, onClickTag }) => {
    const iconUrl = appInstanceIconUrl(app);
    if (!iconUrl) return null;
    return (
      <AppPickerItem
        className="media-item"
        onClick={() => onToggleSelection(app)}
        selected={selected}
      >
        <div className="media-core">
          <div className="media-alpha">
            <ThumbnailPreview iconUrl={iconUrl} name={app.name!} />
            <MediaTitle app={app} onClickTag={onClickTag} />
          </div>
        </div>
        <div className="media-checked">
          <Icon name="checked-circle" />
        </div>
      </AppPickerItem>
    );
  },
);

interface QuickPostsProps {
  appInstances: QuickPostInstanceItemProps["app"][];
  selectedIds: string[];
  onToggleSelection: (app: QuickPostInstanceItemProps["app"]) => void;
  renderFetchMoreButton: React.ReactNode;
  onClickTag: (tag: string) => void;
  secureMediaPolicy?: string;
}

export const QuickPostInstances = ({
  appInstances,
  selectedIds,
  onToggleSelection,
  renderFetchMoreButton,
  onClickTag,
}: QuickPostsProps) => {
  return (
    <>
      {appInstances?.map((app) => (
        <QuickPostInstanceItem
          key={app.id}
          app={app}
          selected={selectedIds.includes(app.id)}
          onToggleSelection={onToggleSelection}
          onClickTag={onClickTag}
        />
      ))}
      {renderFetchMoreButton}
    </>
  );
};
